module.exports = __webpack_public_path__ + "static/media/400077_02.4e998223.png";